import { enums } from '@kattana-io/common';

const binanceSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.twoHours,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.sixHours,
  enums.ETimeframes.eightHours,
  enums.ETimeframes.twelveHours,
  enums.ETimeframes.day,
  enums.ETimeframes.threeDays,
  enums.ETimeframes.week,
  enums.ETimeframes.month,
];

const gateioSupportedResolutions = [
  enums.ETimeframes.tenSeconds,
  enums.ETimeframes.minute,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.eightHours,
  enums.ETimeframes.day,
  enums.ETimeframes.week,
];

const hitbtcSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.day,
  enums.ETimeframes.week,
];

const huobiSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.day,
  enums.ETimeframes.threeDays,
  enums.ETimeframes.week,
];

const kucoinSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.twoHours,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.sixHours,
  enums.ETimeframes.eightHours,
  enums.ETimeframes.twelveHours,
  enums.ETimeframes.day,
  enums.ETimeframes.threeDays,
  enums.ETimeframes.week,
];

const okxSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.twoHours,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.sixHours,
  enums.ETimeframes.twelveHours,
  enums.ETimeframes.day,
  enums.ETimeframes.threeDays,
  enums.ETimeframes.week,
];

const bybitSupportedResolutions = [
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.twoHours,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.sixHours,
  enums.ETimeframes.twelveHours,
  enums.ETimeframes.day,
  enums.ETimeframes.week,
];

const dexSupportedResolutions = [
  enums.ETimeframes.second,
  enums.ETimeframes.fiveSeconds,
  enums.ETimeframes.tenSeconds,
  enums.ETimeframes.minute,
  enums.ETimeframes.threeMinutes,
  enums.ETimeframes.fiveMinutes,
  enums.ETimeframes.fifteenMinutes,
  enums.ETimeframes.thirtyMinutes,
  enums.ETimeframes.hour,
  enums.ETimeframes.twoHours,
  enums.ETimeframes.fourHours,
  enums.ETimeframes.sixHours,
  enums.ETimeframes.eightHours,
  enums.ETimeframes.twelveHours,
  enums.ETimeframes.day,
  enums.ETimeframes.week,
  enums.ETimeframes.month,
];

export {
  binanceSupportedResolutions,
  gateioSupportedResolutions,
  hitbtcSupportedResolutions,
  huobiSupportedResolutions,
  kucoinSupportedResolutions,
  okxSupportedResolutions,
  bybitSupportedResolutions,
  dexSupportedResolutions,
};
